import React from 'react';
import { addModule, addReducers } from '../connector';
import Home from './Home';
// import {Icon} from 'common/components'
export const ROOT = '/brand';
export const MODULE = 'BRAND';


// addReducers({ admins: reducers });
addModule(
    { path: `${ROOT}`, component: Home, title: "Brand", exact: 0, hideNav: 1 },
)
